import { render } from "./ExpandCollapseTransition.vue?vue&type=template&id=da9f9e92&ts=true"
import script from "./ExpandCollapseTransition.vue?vue&type=script&lang=ts"
export * from "./ExpandCollapseTransition.vue?vue&type=script&lang=ts"

import "./ExpandCollapseTransition.vue?vue&type=style&index=0&id=da9f9e92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__